<template>
  <fieldset class="fieldset">
    <legend class="fieldset__label">{{ title }}</legend>
    <div class="search-filter__statuses">
      <label
        v-for="(status, id) in statuses"
        :key="id"
        class="search-filter__status"
        @click="$emit('status-changed', {
          status: status,
          isChecked: isStatusChecked(id)
        })"
      >
        <svg width="20" height="20">
          <use :xlink:href="status.icon" />
        </svg>

        <span :class="`search-filter__status-name ${isStatusChecked(id)?'is_checked':''}`">
          {{ status.name }}
        </span>
      </label>
    </div>
  </fieldset>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: () => ''
    },
    statuses: {
      required: true
    },
    searchStatuses: {
      required: true
    }
  },

  methods: {
    isStatusChecked(id) {
      return this.searchStatuses.findIndex(i => i.id===id) === -1? false: true;
    }
  }
};
</script>